import PropTypes from "prop-types";
import React from "react";

function Card({ children, title, bg }) {
  return (
    <div className={`amellis__card amellis__card--${bg}`}>
      <div className="amellis__card--title">{title}</div>
      <div className="amellis__card--body">{children}</div>
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(Card);
